const Ukraine = () => {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 24 24' fill='none'>
			<g clipPath='url(#clip0_584_16252)'>
				<path
					d='M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z'
					fill='#FFDA44'
				/>
				<path d='M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12' fill='#338AF3' />
			</g>
			<defs>
				<clipPath id='clip0_584_16252'>
					<rect width='24' height='24' fill='white' />
				</clipPath>
			</defs>
		</svg>
	);
};

export default Ukraine;
